<template>
    <div class="report-container">
      <!-- 标题栏 -->
      <div class="header-bar">
        <div class="tag-first-layer">第一层</div>
        <h1 class="main-title">班级整体画像（宏观决策）</h1>
      </div>
  
      <!-- 数据卡片行 -->
      <div class="card-row">
        
        <!-- 班级均分 -->
        <div class="stat-card card-blue">
          <div class="card-title">班级均分</div>
          <div class="card-value">62.7</div>
          <div class="card-desc red">
            ↓ 低于年级均分 1.82分
          </div>
        </div>
  
        <!-- 最高分 -->
        <div class="stat-card card-green">
          <div class="card-title">最高分</div>
          <div class="card-value">129.5</div>
          <div class="card-desc">
            粟辉艳（年级第1名）
          </div>
        </div>
  
        <!-- 最低分 -->
        <div class="stat-card card-red">
          <div class="card-title">最低分</div>
          <div class="card-value">8.0</div>
          <div class="card-desc red">
            需重点关注（2人并列）
          </div>
        </div>
  
        <!-- 标准差 -->
        <div class="stat-card card-blue">
          <div class="card-title">标准差</div>
          <div class="card-value">28.4</div>
          <div class="card-desc">
            成绩离散程度较大
          </div>
        </div>
  
        <!-- 及格率 -->
        <div class="stat-card card-yellow">
          <div class="card-title">及格率</div>
          <div class="card-value">58%</div>
          <div class="card-desc red">
            低于年级平均6个百分点
          </div>
        </div>
  
        <!-- 优秀率 -->
        <div class="stat-card card-green">
          <div class="card-title">优秀率（≥90）</div>
          <div class="card-value">16%</div>
          <div class="card-desc">
            8人达到优秀水平
          </div>
        </div>
      </div>
  

      <!-- 图表区域 -->
      <div class="chart-row">
        <!-- 成绩分布直方图 -->
        <div class="chart-card">
          <h3 class="chart-title">成绩分布直方图</h3>
          <div ref="histogramRef" class="chart-container"></div>
        </div>
  
        <!-- 学业等级结构 -->
        <div class="chart-card">
          <h3 class="chart-title">学业等级结构（A/B/C/D/E）</h3>
          <div ref="pieRef" class="chart-container"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import * as echarts from 'echarts'
  
  // 图表DOM引用
  const histogramRef = ref(null)
  const pieRef = ref(null)
  
  // 初始化直方图
  const initHistogram = () => {
    const chart = echarts.init(histogramRef.value)
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: ['0-20', '20-40', '40-60', '60-80', '80-100', '100-120', '120-140'],
        axisTick: { alignWithLabel: true }
      },
      yAxis: {
        type: 'value',
        max: 20,
        interval: 2
      },
      series: [
        {
          name: '人数',
          type: 'bar',
          barWidth: '70%',
          data: [
            { value: 4, itemStyle: { color: '#f04e30' } },
            { value: 6, itemStyle: { color: '#f1453d' } },
            { value: 10, itemStyle: { color: '#f59e0b' } },
            { value: 16, itemStyle: { color: '#3b82f6' } },
            { value: 9, itemStyle: { color: '#10b981' } },
            { value: 3, itemStyle: { color: '#10b981' } },
            { value: 2, itemStyle: { color: '#8b5cf6' } }
          ]
        }
      ]
    }
    chart.setOption(option)
    // 自适应窗口大小
    window.addEventListener('resize', () => chart.resize())
  }
  
  // 初始化环形饼图
  const initPieChart = () => {
    const chart = echarts.init(pieRef.value)
    const option = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        bottom: 0,
        left: 'center',
        data: ['A等(优秀)', 'B等(良好)', 'C等(中等)', 'D等(及格)', 'E等(不及格)'],
        formatter: (name) => {
          const colorMap = {
            'A等(优秀)': '#10b981',
            'B等(良好)': '#3b82f6',
            'C等(中等)': '#f59e0b',
            'D等(及格)': '#f97316',
            'E等(不及格)': '#ef4444'
          }
          return `{${colorMap[name]}|} ${name}`
        },
        textStyle: {
          rich: {
            '#10b981': { color: '#10b981', fontSize: 12 },
            '#3b82f6': { color: '#3b82f6', fontSize: 12 },
            '#f59e0b': { color: '#f59e0b', fontSize: 12 },
            '#f97316': { color: '#f97316', fontSize: 12 },
            '#ef4444': { color: '#ef4444', fontSize: 12 }
          }
        }
      },
      series: [
        {
          name: '学业等级',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 4,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 16,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [
            { value: 8, name: 'A等(优秀)', itemStyle: { color: '#10b981' } },
            { value: 29, name: 'B等(良好)', itemStyle: { color: '#3b82f6' } },
            { value: 25, name: 'C等(中等)', itemStyle: { color: '#f59e0b' } },
            { value: 16, name: 'D等(及格)', itemStyle: { color: '#f97316' } },
            { value: 4, name: 'E等(不及格)', itemStyle: { color: '#ef4444' } }
          ]
        }
      ]
    }
    chart.setOption(option)
    window.addEventListener('resize', () => chart.resize())
  }
  
  onMounted(() => {
    initHistogram()
    initPieChart()
  })
  </script>
  
  <style scoped>
  .report-container {
    padding: 20px;
    background-color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  }
  
  /* 标题栏 */
  .header-bar {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #3b82f6;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  
  .tag-first-layer {
    background-color: #3b82f6;
    color: #ffffff;
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    margin-right: 12px;
  }
  
  .main-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
  }
  
  /* 数据卡片行 */
  .card-row {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
  }
  
  .stat-card {
    flex: 1;
    background-color: #f8fafc;
    border-radius: 8px;
    padding: 20px;
    border-left: 4px solid;
  }
  
  /* 卡片边框颜色 */
  .card-blue { border-left-color: #3b82f6; }
  .card-green { border-left-color: #10b981; }
  .card-red { border-left-color: #ef4444; }
  .card-yellow { border-left-color: #f59e0b; }
  
  .card-title {
    font-size: 16px;
    color: #475569;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  .card-value {
    font-size: 32px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
  }
  
  .card-desc {
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
  }
  
  .card-desc.red {
    color: #ef4444;
  }
  
  /* 关键发现 */
  .warning-section {
    background-color: #fef3c7;
    border-radius: 8px;
    padding: 16px 20px;
    margin-bottom: 24px;
  }
  
  .warning-title {
    font-size: 18px;
    font-weight: 600;
    color: #92400e;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }
  
  .warning-icon {
    margin-right: 8px;
    font-size: 20px;
  }
  
  .warning-content {
    font-size: 16px;
    color: #78350f;
    line-height: 1.6;
    margin: 0;
  }
  
  /* 图表行 */
  .chart-row {
    display: flex;
    gap: 20px;
  }
  
  .chart-card {
    flex: 1;
    background-color: #fafafa;
    border-radius: 8px;
    padding: 16px;
  }
  
  .chart-title {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 16px 0;
  }
  
  .chart-container {
    width: 100%;
    height: 300px;
  }
  </style>